<template>
  <b-modal :active.sync="isActiveLocal" scroll="keep">
    <video controls :src="`${publicPath}kyc-forms-screencast.mp4`"/>
  </b-modal>
</template>

<script>
export default {
  name: 'HelpModal',
  props: ['isActive'],
  data () {
    return {
      isActiveLocal: this.isActive,
      publicPath: process.env.BASE_URL
    }
  },
  watch: {
    isActiveLocal () {
      this.$emit('is-active-changed', this.isActiveLocal)
    },
    isActive () {
      this.isActiveLocal = this.isActive
    }
  }
}
</script>
